import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import RichTextFormField from 'components/RichText/FormField'
import classes from './MessageForm.module.scss'

export class MessageForm extends React.Component {
  static propTypes = {
    richTextEditorProps: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired
  }

  render () {
    const {
      richTextEditorProps,
      handleSubmit
    } = this.props

    return (
      <div className={classes.messageForm}>
        <Field
          name='message'
          component={RichTextFormField}
          props={{
            richTextEditorProps: {
              ...richTextEditorProps,
              className: classes.messageFormEditor,
              onSubmit: () => handleSubmit()
            },
            errorOnTouched: false,
            style: {
              marginBottom: 0
            }
          }}
        />
      </div>
    )
  }
}

export default reduxForm({
  form: 'message'
})(MessageForm)
